(() => {
  if (window.RCDayCloudsReady) return;
  window.RCDayCloudsReady = true;
  function init(canvas) {
  if (!canvas || canvas.dataset.initialized) return;
  canvas.dataset.initialized = 'true';
  const stage = canvas.parentElement;
  const layers = [...stage.querySelectorAll('.rc-cloud-fallback__track')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const appearance = matchMedia('(prefers-color-scheme: light)');
  const gate = canvas.closest('[data-door-stage]');
  const root = document.documentElement;
  let started = false, suspended = false;
  const visible = () => gate ? !gate.hidden : !root.classList.contains('rc-door-active');
  const flashFallback = document.createElement('div');
  flashFallback.className = 'rc-cloud-fallback-flash'; stage.appendChild(flashFallback);
  let gl, program, buffer, texture, vertex, fragment, locations, image;
  let ready = false, disposed = false, raf = 0, last = 0, cloudTime = 0, clock = 0;
  let travel = 0, scrollPosition = 0, pendingScroll = 0, targetVelocity = 0, scrollVelocity = 0;
  let flowRate = .0028, lightningEnergy = 0, scrollCharge = 0;
  const speed = 1;
  let nextFlash = 5.2, flashStart = -100, flashes = 0, frames = 0;
  let flashOrigin = [.5, .58];
  const paused = () => reduce.matches || root.classList.contains('rc-motion-paused');
  const active = () => appearance.matches && !paused() && !document.hidden && !suspended && visible();
  const vertexSource = 'attribute vec2 aPosition;varying vec2 vUv;void main(){vUv=aPosition*.5+.5;gl_Position=vec4(aPosition,0.,1.);}';
  const fragmentSource = `
    precision highp float;
    varying vec2 vUv;
    uniform sampler2D uCloud;
    uniform vec2 uResolution;
    uniform float uImageAspect;
    uniform float uTime;
    uniform float uTravel;
    uniform float uFlash;
    uniform vec2 uFlashOrigin;
    float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
    float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);}
    float fbm(vec2 p){float n=0.;float a=.55;for(int i=0;i<3;i++){n+=a*noise(p);p=p*2.03+vec2(4.1,2.7);a*=.5;}return n;}
    float cloud(vec2 uv){float y=fract(uv.y);float w=smoothstep(0.,.12,y)*(1.-smoothstep(.88,1.,y));float a=texture2D(uCloud,vec2(clamp(uv.x,.015,.985),y)).r;float b=texture2D(uCloud,vec2(clamp(uv.x,.015,.985),fract(y+.5))).r;return mix(b,a,w);}
    void main(){
      float aspect=uResolution.x/uResolution.y;
      vec2 cover=vec2(min(1.,aspect/uImageAspect),min(1.,uImageAspect/aspect));
      vec2 uv=(vUv-.5)*cover+.5;
      float t=uTime*.055;
      vec2 warp=vec2(fbm(uv*vec2(3.2,2.7)+vec2(t*.29,-t*.34)),fbm(uv*vec2(2.7,3.8)+vec2(-t*.24,t*.22)))-.45;
      vec2 cells=uv*vec2(6.4,8.2);
      vec2 billow=vec2(fbm(cells+vec2(t*.38,-t*.61)),fbm(cells.yx+vec2(5.3-t*.42,t*.31)))-.45;
      vec2 breeze=vec2(sin(uTime*.026)*.009,0.);
      float farCloud=cloud(uv+warp*.037+billow*.012+breeze-vec2(0.,uTravel));
      vec2 nearUv=(uv-.5)*vec2(.84,1.12)+.5+vec2(.07,.37)+warp*.049-billow*.021;
      float nearCloud=cloud(nearUv+breeze*.65-vec2(0.,uTravel*1.428571));
      float veil=fbm(cells*.58+vec2(-t*.21,t*.27));
      float shade=mix(farCloud,nearCloud,.18+veil*.12);
      vec2 rightUv=vec2(.93-uv.x*.86,uv.y*.96+.23)+warp*.043+billow*.017+breeze*.45;
      float rightCloud=cloud(rightUv-vec2(0.,uTravel*1.16));
      float rightBank=smoothstep(.42,.97,vUv.x)*(.14+veil*.15);
      shade=mix(shade,rightCloud,rightBank);
      shade=clamp(shade*.96+.045,.28,1.);
      vec2 p=vec2(vUv.x*aspect,vUv.y);
      vec2 o=vec2(uFlashOrigin.x*aspect,uFlashOrigin.y);
      vec2 q=(p-o)*vec2(1.,1.25);
      vec2 q2=q+vec2(.065,-.045),q3=q-vec2(.05,.065);
      float sheet=exp(-dot(q,q)*42.)*.64+exp(-dot(q2,q2)*90.)*.28+exp(-dot(q3,q3)*145.)*.18;
      float cloudDepth=1.-smoothstep(.52,.96,shade);
      float scatter=.65+.35*fbm(uv*vec2(12.,15.)+warp*.3);
      float light=clamp(sheet*cloudDepth*scatter*uFlash*.98,0.,.6);
      shade=mix(shade,.995,light);
      gl_FragColor=vec4(vec3(shade),1.);
    }
  `;
  function useFallback(reason) {
    stage.classList.add('is-fallback');
    canvas.dataset.renderer = 'css';
    if (reason) canvas.dataset.fallbackReason = reason;
    layers.forEach(layer => layer.querySelectorAll('img').forEach(img => { img.src = canvas.dataset.cloudSource; }));
    gl = null; ready = true; draw(); schedule();
  }
  function compile(type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source); gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      const message = gl.getShaderInfoLog(shader); gl.deleteShader(shader); throw new Error(message);
    }
    return shader;
  }
  function resize() {
    const scale = Math.min(.9, 1024 / window.innerWidth, Math.sqrt(900000 / (window.innerWidth * window.innerHeight)));
    canvas.width = Math.round(window.innerWidth * scale);
    canvas.height = Math.round(window.innerHeight * scale);
    if (gl) gl.viewport(0, 0, canvas.width, canvas.height);
    scrollPosition = readScroll();
    if (ready) draw();
  }
  function readScroll() {
    const scroller = document.scrollingElement || document.documentElement;
    const max = Math.max(0, scroller.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(window.scrollY || scroller.scrollTop || 0, max));
  }
  function onScroll() {
    const position = readScroll();
    const distance = position - scrollPosition;
    scrollPosition = position;
    if (!ready || !active() || disposed) return;
    pendingScroll += distance / Math.max(window.innerHeight, 1);
  }
  function resetGesture() {
    pendingScroll = targetVelocity = scrollVelocity = 0;
    flowRate = .0028 * speed; lightningEnergy = scrollCharge = 0;
    scrollPosition = readScroll();
  }
  function advanceGesture(delta) {
    const input = pendingScroll;
    pendingScroll = 0;
    if (input) targetVelocity = Math.max(-4.5, Math.min(4.5, input / Math.max(delta, 1 / 30)));
    else targetVelocity *= Math.exp(-delta / .26);
    scrollVelocity += (targetVelocity - scrollVelocity) * (1 - Math.exp(-delta / .14));
    flowRate = .0028 * speed + scrollVelocity * .075;
    travel += delta * flowRate;
    const energyTarget = Math.max(0, scrollVelocity) / 4.5;
    lightningEnergy += (energyTarget - lightningEnergy) * (1 - Math.exp(-delta / (energyTarget > lightningEnergy ? .12 : .8)));
    scrollCharge = input > 0 ? Math.min(.8, scrollCharge + input) : input < 0 ? 0 : scrollCharge * Math.exp(-delta / 1.2);
    if (input > 0 && scrollCharge > .18 && lightningEnergy > .12 && clock - flashStart > 2.8) {
      triggerFlash(); scrollCharge = 0;
    }
  }
  function flashAmount() {
    if (paused()) return 0;
    const age = clock - flashStart;
    return age >= 0 && age <= .85 ? (1 - Math.exp(-age * 34)) * Math.exp(-age * 5.2) * 1.2 : 0;
  }
  function draw() {
    if (!ready || disposed || !appearance.matches || !visible() || document.hidden) return;
    const flashGain = 1 + lightningEnergy * 2.5;
    const flash = flashAmount() * flashGain;
    canvas.dataset.flash = flash.toFixed(3);
    canvas.dataset.flashGain = flashGain.toFixed(3);
    if (gl) {
      gl.useProgram(program);
      gl.uniform2f(locations.resolution, canvas.width, canvas.height);
      gl.uniform1f(locations.time, cloudTime);
      gl.uniform1f(locations.travel, travel);
      gl.uniform1f(locations.flash, flash);
      gl.uniform2f(locations.flashOrigin, flashOrigin[0], flashOrigin[1]);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    } else {
      layers.forEach((layer, i) => {
        const phase = ((travel * (i ? 1.428571 : 1) + (i ? .37 : 0)) % 1 + 1) % 1;
        layer.style.translate = `0 ${-phase * 50}%`;
      });
      flashFallback.style.opacity = String(flash * .23);
    }
    canvas.dataset.travel = travel.toFixed(5);
    canvas.dataset.scrollVelocity = scrollVelocity.toFixed(3);
    canvas.dataset.flowRate = flowRate.toFixed(5);
    canvas.dataset.scale = '1.0000';
    canvas.dataset.scrollDirection = scrollVelocity > .03 ? 'forward' : scrollVelocity < -.03 ? 'reverse' : 'idle';
    frames++;
    if (frames === 1 || frames % 15 === 0) {
      canvas.dataset.frames = String(frames);
      canvas.dataset.cloudTime = cloudTime.toFixed(3);
    }
  }
  function triggerFlash() {
    if (paused() || disposed || clock - flashStart < 1.8) return;
    flashStart = clock; flashes++;
    flashOrigin = [.23 + ((Math.sin(flashes * 7.13) + 1) * .5) * .54, .35 + ((Math.cos(flashes * 4.2) + 1) * .5) * .4];
    nextFlash = clock + 9 + (Math.sin(flashes * 2.37) + 1) * 3;
    canvas.dataset.flashes = String(flashes);
    flashFallback.style.setProperty('--flash-x', flashOrigin[0] * 100 + '%');
    flashFallback.style.setProperty('--flash-y', (1 - flashOrigin[1]) * 100 + '%');
  }
  function frame(now) {
    raf = 0;
    if (disposed || !active() || !ready) return;
    if (last && now - last < 1000 / 30) { schedule(); return; }
    const delta = last ? Math.min((now - last) / 1000, .08) : 0;
    last = now; clock += delta;
    cloudTime += delta * speed * (1 + Math.min(Math.abs(scrollVelocity), 2.5) * .22);
    advanceGesture(delta);
    if (clock >= nextFlash) triggerFlash();
    draw(); schedule();
  }
  function schedule() {
    if (!raf && ready && !disposed && active()) raf = requestAnimationFrame(frame);
  }
  function sync() {
    if (disposed) return;
    canvas.dataset.appearance = appearance.matches ? 'light' : 'dark';
    canvas.dataset.motion = !appearance.matches ? 'inactive' : reduce.matches ? 'reduced' : paused() ? 'paused' : active() ? 'running' : 'suspended';
    if (raf) cancelAnimationFrame(raf); raf = 0; last = 0;
    resetGesture(); flashStart = -100;
    if (appearance.matches && visible() && !document.hidden && !started) startRenderer();
    if (!document.hidden) draw();
    schedule();
  }
  function hide(event) {
    if (event.persisted) { suspended = true; sync(); }
    else destroy();
  }
  function show() { suspended = false; sync(); }
  function destroy() {
    if (disposed) return;
    disposed = true;
    if (raf) cancelAnimationFrame(raf); raf = 0;
    observer.disconnect();
    document.removeEventListener('visibilitychange', sync);
    window.removeEventListener('resize', resize);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('pagehide', hide);
    window.removeEventListener('pageshow', show);
    reduce.removeEventListener('change', sync);
    appearance.removeEventListener('change', sync);
    if (image) image.onload = image.onerror = null;
    if (gl) {
      gl.deleteTexture(texture); gl.deleteBuffer(buffer); gl.deleteProgram(program);
      gl.deleteShader(vertex); gl.deleteShader(fragment);
    }
    delete canvas.dataset.initialized;
  }
  const observer = new MutationObserver(sync);
  observer.observe(root, { attributes: true, attributeFilter: ['class'] });
  if (gate) observer.observe(gate, { attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('visibilitychange', sync);
  reduce.addEventListener('change', sync);
  appearance.addEventListener('change', sync);
  window.addEventListener('resize', resize, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pagehide', hide);
  window.addEventListener('pageshow', show);
  canvas.addEventListener('rc-clouds:destroy', destroy, { once: true });
  canvas.addEventListener('webglcontextlost', event => { event.preventDefault(); useFallback('context-lost'); });
  canvas.dataset.direction = 'up'; canvas.dataset.speed = '1'; canvas.dataset.flashes = '0';
  canvas.dataset.effect = 'scroll-vertical'; canvas.dataset.lightning = 'scroll-linked-in-cloud';
  canvas.dataset.revision = 'day-clouds-01';
  function startRenderer() {
    started = true;
  try {
    gl = canvas.getContext('webgl', { alpha: false, antialias: false, powerPreference: 'low-power' });
    if (!gl) { useFallback('webgl-unavailable'); return; }
    vertex = compile(gl.VERTEX_SHADER, vertexSource); fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
    program = gl.createProgram(); gl.attachShader(program, vertex); gl.attachShader(program, fragment); gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
    gl.useProgram(program);
    buffer = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);
    const position = gl.getAttribLocation(program, 'aPosition');
    gl.enableVertexAttribArray(position); gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
    locations = Object.fromEntries([['resolution','uResolution'],['time','uTime'],['travel','uTravel'],['flash','uFlash'],['flashOrigin','uFlashOrigin']].map(([key,name])=>[key,gl.getUniformLocation(program,name)]));
    texture = gl.createTexture(); gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    image = new Image();
    image.onload = () => {
      if (disposed || !gl) return;
      gl.bindTexture(gl.TEXTURE_2D, texture); gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
      gl.uniform1i(gl.getUniformLocation(program,'uCloud'), 0);
      gl.uniform1f(gl.getUniformLocation(program,'uImageAspect'), image.naturalWidth/image.naturalHeight);
      canvas.dataset.renderer = 'webgl'; ready = true; resize(); sync();
    };
    image.onerror = () => useFallback('texture-unavailable');
    image.src = canvas.dataset.cloudSource;
  } catch (error) {
    useFallback('shader-unavailable');
    console.warn('Cloud preview uses CSS fallback:', error.message);
  }
  }
  resize(); sync();
  }
  const scan = scope => scope.querySelectorAll('[data-rc-clouds]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rc-clouds]').forEach(canvas => canvas.dispatchEvent(new Event('rc-clouds:destroy'))));
})();
